var map = {
	"./aluminum-window.jpg": "0ca2",
	"./autoParts.jpg": "8ac0",
	"./brake.jpg": "8649",
	"./ceramic-tiles.jpg": "6083",
	"./control-arm.jpg": "b88a",
	"./engine-piston.jpg": "d4b1",
	"./facebook.png": "7e8d",
	"./factory-cnc.jpg": "424b",
	"./faucet.jpg": "9ee8",
	"./glueMachinery.jpg": "45fc",
	"./hero-banner-1.jpg": "8f82",
	"./hero-banner-2.jpg": "53ab",
	"./hero-banner-3.jpg": "098c",
	"./logo.png": "6de0",
	"./marble.jpg": "2518",
	"./pipes.jpg": "7d67",
	"./qc-lab.jpg": "7c62",
	"./qrcode1.png": "97e0",
	"./qrcode2.png": "a5a2",
	"./qrcode3.png": "5cbf",
	"./sanitaryWare.jpg": "e257",
	"./solve.png": "5533",
	"./tie-rod.jpg": "49f5",
	"./trap.png": "a20f",
	"./warehouse.jpg": "2b71",
	"./warn.png": "a459",
	"./waterproofing.jpg": "ca35",
	"./woodenDoor.jpg": "6169"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f259";